import { GameId } from "~/services/blastApi/shared/schemas/GameId";

export const gameTitles: Record<GameId, string> = {
  cs: "CS2",
  dota: "Dota 2",
  gaming: "News",
  rl: "Rocket League",
  pubg: "PUBG",
  fr: "BLAST.tv Fr",
};
